import { gql } from '@apollo/client'
import { STATUS_CANCELLED, STATUS_CANCELLED_BY_USER, ORDER_STATUS } from '../types/Order'

export const GET_SUMARY_DATA = gql`
  query DailyMonitoringCancelled($filters: DailyMonitoringInput!) {
    dailyMonitoringCancelled(filters: $filters) {
      ordersCheckoutTotal
      ordersCancelledTotal
      ordersCancelledQuantity
      ordersCancelledAverage
      ordersCancelledPercentage
    }
  }
`

export const GET_CHECKOUT_ORDERS_TOTAL_HISTORY = gql`
  query CheckoutOrdersTotalHistory($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                new_status: ["${ORDER_STATUS.WAITING_CONFIRMATION}", "${ORDER_STATUS.AVAILABLE}", "${ORDER_STATUS.CONFIRMED}", "${ORDER_STATUS.DELIVERING}"]
              }
            }
          ]
        }
      },
      aggs: {
        salesOverTime: {
          date_histogram: {
            field: "created_at",
            calendar_interval: "day",
            time_zone: "-03:00"
          },
          aggs: {
            total: {
              sum: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_ORDERS_CANCELLED_TOTAL_HISTORY = gql`
  query OrdersTotalHistory($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                status_translate_keyword: ["${STATUS_CANCELLED}", "${STATUS_CANCELLED_BY_USER}"]
              }
            }
          ]
        }
      },
      aggs: {
        salesOverTime: {
          date_histogram: {
            field: "created_at",
            calendar_interval: "day",
            time_zone: "-03:00"
          },
          aggs: {
            total: {
              sum: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_ORDERS_QUANTITY_HISTORY = gql`
  query OrdersQuantityHistory($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                status_translate_keyword: ["${STATUS_CANCELLED}", "${STATUS_CANCELLED_BY_USER}"]
              }
            }
          ]
        }
      },
      aggs: {
        salesOverTime: {
          date_histogram: {
            field: "created_at",
            calendar_interval: "day",
            time_zone: "-03:00"
          },
          aggs: {
            quantity: {
              value_count: {
                field: "_id"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_ORDERS_AVERAGE_HISTORY = gql`
  query OrdersAverageHistory($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              terms: {
                status_translate_keyword: ["${STATUS_CANCELLED}", "${STATUS_CANCELLED_BY_USER}"]
              }
            }
          ]
        }
      },
      aggs: {
        salesOverTime: {
          date_histogram: {
            field: "created_at",
            calendar_interval: "day",
            time_zone: "-03:00"
          },
          aggs: {
            total: {
              avg: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`
